module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Cadastrar', {
    attrs: {
      "showForm": _vm.showFormCadastro,
      "parent": this
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Desativar Nova Empresa",
      "onRegister": (this.validarPermissao(310) ? _vm.onRegister : null),
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getDesativado,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13ca61fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/periodico/desativado/index.vue
// module id = 1450
// module chunks = 45